export default __webpack_public_path__ + "static/media/title-dentro-fora.46ff27a7.png";